import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { DeletedStepsCreate, DeletedStepsDelete, DeletedStepsRefresh } from './deleted-step.action';
import { WFStepLocalResource } from 'src/app/components/workflow/workflow';
import { ChecklistBuilderService } from '../../checklist-builder/checklist-builder.service';

export class DeletedStepsStateModel {
  data: WFStepLocalResource[] = [];
}

@State<DeletedStepsStateModel>({
  name: 'DeletedWFStepLocals',
  defaults: {
    data: [],
  },
})
@Injectable()
export class DeletedStepsState extends BaseState {
  constructor(
    protected override injector: Injector, private service: ChecklistBuilderService
  ) {
    super(injector);
  }

  @Selector()
  static read(state: DeletedStepsStateModel) {
    return state.data;
  }

  @Action(DeletedStepsRefresh)
  refresh({ patchState }: StateContext<DeletedStepsStateModel>, { checklistTemplateID }: DeletedStepsRefresh) {
    this.service.getDeletedSteps(checklistTemplateID).toPromise().then((data) => {
      patchState({ data });
    },
      (error) => console.error(error)
    );
  }

  @Action(DeletedStepsCreate)
  create({ getState, patchState }: StateContext<DeletedStepsStateModel>, { item }: DeletedStepsCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(DeletedStepsDelete)
  delete({ getState, patchState }: StateContext<DeletedStepsStateModel>, { logID }: DeletedStepsDelete) {
    patchState({ data: getState().data.filter((x) => x.logID !== logID) });
  }
}
